/* global jQuery */
/* global require */
'use strict'; //eslint-disable-line

const angular = require('angular');
require('moment');
require('angular-cookies');
require('angular-route');
require('angular-resource');
require('angular-environment');
require('angular-translate');
require('angular-translate-loader-static-files');
require('../static/js/angular-jwt');
require('ng-file-upload'); //eslint-disable-line
require('angular-paging');
require('lodash'); //eslint-disable-line
require('angular-simple-logger'); //eslint-disable-line
require('angular-google-maps');
require('angular-touch');
require('angular-animate');
require('angular-chart.js');
require('angular-jquery-timepicker');
require('moment');
require('angular-ui-calendar');
require('angular-ui-sortable');
require('angularjs-datepicker');

require('./app.module.js');
require('./app.directive.js');
require('./app.config.js');
require('./app.ctrl.js');

require('./core/core.module.js');
require('./core/auth/auth.module.js');
require('./core/auth/auth.service.js');
require('./core/env/env.module.js');
require('./core/env/env.config.js');
require('./core/filter/date.filter.js');
require('./core/filter/html.filter.js');

require('./member/member');
require('./employee/map');
require('./employee/employee');
require('./employee/holidays/holidays');
require('./service/service');
require('./orders/orders');

// Product
require('./goods-list/goods-list.module.js');
require('./goods-list/goods-list.component.js');

require('./goods-add/goods-add.module.js');
require('./goods-add/goods-add.component.js');

// Options
require('./options-list/options-list.module.js');
require('./options-list/options-list.component.js');

require('./options-add/options-add.module.js');
require('./options-add/options-add.component.js');

// Wash Reserve Wait
require('./orders-wait/orders-wait.module.js');
require('./orders-wait/orders-wait.component.js');

// Wash Order Rate Managements
require('./orders-rates/orders-rates.module.js');
require('./orders-rates/orders-rates.component.js');

// Order Search
require('./orders-search/orders-search.module');
require('./orders-search/orders-search.component');

require('./orders-subscription/orders-subscription.module.js');
require('./orders-subscription/orders-subscription.component.js');

require('./orders-subscription-add/orders-subscription-add.module.js');
require('./orders-subscription-add/orders-subscription-add.component.js');

require('./subscription-product/subscription-product.module.js');
require('./subscription-product/subscription-product.component.js');
require('./subscription-product-add/subscription-product-add.module.js');
require('./subscription-product-add/subscription-product-add.component.js');
require('./sentences/sentences.module.js');
require('./sentences/sentences.component.js');

require('./washes-count/washes-count.module.js');
require('./washes-count/washes-count.component.js');

require('./washes-dashboard/washes-dashboard.module.js');
require('./washes-dashboard/washes-dashboard.component.js');

require('./washes-revenue/washes-revenue.module.js');
require('./washes-revenue/washes-revenue.component.js');

require('./washes-revenue-detail/washes-revenue-detail.module');
require('./washes-revenue-detail/washes-revenue-detail.component');

require('./balance-bm-point/balance-bm-point.module.js');
require('./balance-bm-point/balance-bm-point.component.js');

require('./balance-download/balance-download.module.js');
require('./balance-download/balance-download.component.js');

require('./blacklist/blacklist.module.js');
require('./blacklist/blacklist.component.js');
require('./blacklist-add/blacklist-add.module.js');
require('./blacklist-add/blacklist-add.component.js');

require('./affiliate-company/affiliate-company.module');
require('./affiliate-company/affiliate-company.component');
require('./affiliate-company-add/affiliate-company-add.module');
require('./affiliate-company-add/affiliate-company-add.component');
require('./affiliate-user/affiliate-user.module');
require('./affiliate-user/affiliate-user.component');

require('./service/setting/setting.module');
require('./service/setting/setting.component');
require('./service/banners/banners.module');
require('./service/banners/banners.component');
require('./service/auto-product/auto-product.module');
require('./service/auto-product/auto-product.component');
require('./service/apps/apps.module');
require('./service/apps/apps.component');
require('./app-setting/transportation/transportation.module');
require('./app-setting/transportation/transportation.component');
require('./app-setting/invite-coupon/invite-coupon.module');
require('./app-setting/invite-coupon/invite-coupon.component');
require('./app-setting/welcome/welcome.module');
require('./app-setting/welcome/welcome.component');
require('./app-setting/tutorial/tutorial.module');
require('./app-setting/tutorial/tutorial.component');
require('./app-setting/order-tutorial/order-tutorial.module');
require('./app-setting/order-tutorial/order-tutorial.component');

require('./boards/push-notification/push-notification.module.js');
require('./boards/push-notification/push-notification.component.js');

require('./percent-coupons/percent-coupons.module');
require('./percent-coupons/percent-coupons.component');

require('./percent-coupons-add/percent-coupons-add.module');
require('./percent-coupons-add/percent-coupons-add.component');

require('./promotion-code/promotion-code.module');
require('./promotion-code/promotion-code.component');

require('./promotion-code-add/promotion-code-add.module');
require('./promotion-code-add/promotion-code-add.component');

require('./event-code/event-code.module');
require('./event-code/event-code.component');


require('./eventcode-users/eventcode-users.module');
require('./eventcode-users/eventcode-users.component');

require('./member-whitelist/member-whitelist.module');
require('./member-whitelist/member-whitelist.component');

require('./member-car-add/member-car-add.module');
require('./member-car-add/member-car-add.component');

require('./boards/inhouse-notice/inhouse-notice-list/inhouse-notice-list.module');
require('./boards/inhouse-notice/inhouse-notice-list/inhouse-notice-list.component');
require('./boards/inhouse-notice/inhouse-notice-add/inhouse-notice-add.module');
require('./boards/inhouse-notice/inhouse-notice-add/inhouse-notice-add.component');
require('./boards/inhouse-notice/inhouse-notice-edit/inhouse-notice-edit.module');
require('./boards/inhouse-notice/inhouse-notice-edit/inhouse-notice-edit.component');
require('./boards/inhouse-notice/inhouse-notice-view/inhouse-notice-view.module');
require('./boards/inhouse-notice/inhouse-notice-view/inhouse-notice-view.component');

require('./member-edit/member-edit.module');
require('./member-edit/member-edit.component');

require('./stat-wash/stat-wash.module');
require('./stat-wash/stat-wash.component');

require('./stat-wdressroom/stat-wdressroom.module');
require('./stat-wdressroom/stat-wdressroom.component');

require('./stat-insurance/stat-insurance.module');
require('./stat-insurance/stat-insurance.component');

require('./stat-wash-byarea/stat-wash-byarea.module');
require('./stat-wash-byarea/stat-wash-byarea.component');

require('./stat-member/stat-member.module');
require('./stat-member/stat-member.component');

require('./stat-employee/stat-employee.module');
require('./stat-employee/stat-employee.component');

require('./stat-vehicle-make/stat-vehicle-make.module');
require('./stat-vehicle-make/stat-vehicle-make.component');

require('./stat-vehicle-count/stat-vehicle-count.module');
require('./stat-vehicle-count/stat-vehicle-count.component');

require('./stat-labor-cost/stat-labor-cost.module');
require('./stat-labor-cost/stat-labor-cost.component');

require('./stat-banner-clicks/stat-banner-clicks.module');
require('./stat-banner-clicks/stat-banner-clicks.component');

require('./employees-by-area/employees-by-area.module');
require('./employees-by-area/employees-by-area.component');

require('./user-leave-reasons/user-leave-reasons.module');
require('./user-leave-reasons/user-leave-reasons.component');
require('./orders-cancel-reasons/orders-cancel-reasons.module');
require('./orders-cancel-reasons/orders-cancel-reasons.component');

require('./duplicated-car/duplicated-car.module');
require('./duplicated-car/duplicated-car.component');

require('./refund-request/refund-request.module');
require('./refund-request/refund-request.component');

require('./refund-point-list/refund-point-list.module');
require('./refund-point-list/refund-point-list.component');

require('./orders-modify-goods/orders-modify-goods.module');
require('./orders-modify-goods/orders-modify-goods.component');

require('./employee/employee-add/employee-add.module');
require('./employee/employee-add/employee-add.component');

require('./employee/employee-edit/employee-edit.module');
require('./employee/employee-edit/employee-edit.component');

require('./event-point/event-point.module');
require('./event-point/event-point.component');

require('./event-time-sale-wash-direct/event-time-sale-wash-direct.module');
require('./event-time-sale-wash-direct/event-time-sale-wash-direct.component');

require('./wash-cancel-request/wash-cancel-request.module');
require('./wash-cancel-request/wash-cancel-request.component');

require('./subscription/orders-subscript.module');
require('./subscription/orders-subscript.component');

require('./subscription-package/subscription-package.module');
require('./subscription-package/subscription-package.component');

require('./stat-insurance-mti/stat-insurance-mti.module');
require('./stat-insurance-mti/stat-insurance-mti.component');

require('./coupons/coupons');
require('./boards/boards');
require('./cars/cars');
require('./service/area/area.module');
require('./service/area/area.components');
require('./service/brands/brands');
require('./point/coupons');
require('./balance/balance');
require('./service/terms/terms');
require('./user-blacklist/user-blacklist.module');
require('./user-blacklist/user-blacklist.component');
require('./detailer-blacklist/detailer-blacklist.module');
require('./detailer-blacklist/detailer-blacklist.component');
require('../static/neon/css/bootstrap.css');
require('../static/neon/css/neon-core.css');
require('../static/neon/css/neon-theme.css');
require('../static/neon/css/neon-forms.css');
require('../static/neon/css/custom.css');
require('../static/css/instawash.css');
require('../static/js/ui-bootstrap-tpls-2.0.0.min');
require('../static/neon/js/daterangepicker/moment.min');
require('../static/neon/js/daterangepicker/daterangepicker-bs3.css');
require('../../node_modules/angularjs-datepicker/src/css/angular-datepicker.css');

angular
  .module('app')
  .factory('CenterInfo', () => { //eslint-disable-line
    return {
      center: {
        latitude: 37.50980,
        longitude: 127.03756,
      },
      updateCenter(lat, lng) {
        this.center.latitude = lat;
        this.center.longitude = lng;
      },
    };
  });

angular
  .module('app')
  .factory('TagConverter', () => { //eslint-disable-line
    return {
      replaceForHtml(str) {
        let contents = str.split('\n').join('<br>');
        contents = contents.split('\u0020').join('&nbsp;');
        return contents;
      },
      replaceForTextArea(str) {
        let contents = str.split('<br>').join('\n');
        contents = contents.split('&nbsp;').join('\u0020');
        return contents;
      },
    };
  });



// WEBPACK FOOTER //
// ./src/app/app.js